import { PATHS } from 'AppConstants';
import { ASSET_PATH } from 'assetsPath';

export const headerImg = {
	landing: `${ASSET_PATH.IMAGES}/travelIntegration/myBizDocsLight.png`,
	detail: `${ASSET_PATH.IMAGES}/travelIntegration/myBizDocsDark.png`
};

export const NavigationLinks = [
	{
		text: 'Benefits',
		type: 'ben',
		link: 'Benefits',
		trackVal: 'benefits_clicked',
		pageurl: PATHS.EXPENSE_SEO
	},
	{
		text: 'Features',
		type: 'case',
		link: 'Features',
		trackVal: 'features_clicked',
		pageurl: PATHS.EXPENSE_SEO
	}
];
